import React from 'react'
import ReactCompareImage from 'react-compare-image'

const ImageComparisonBlock = (props) => {
  return (
    <ReactCompareImage {...props}/>
  )
}

export default ImageComparisonBlock